import moment from 'moment';

export function required(conditionalRequired: boolean = false) {
    if (conditionalRequired) {
        return v => true;
    } else {
        return v => !!v || 'Requerido';
    }
}

export function fieldLength(maxLength: number) {
    return v => !v || v.length <= maxLength || 'El campo no debe exceder el límite de caracteres';
}

export function fieldMinLength(minLength: number) {
    return v =>
        (v && v.length >= minLength) ||
        'El campo debe ser mayor a ' + minLength.toString() + ' caracteres';
}

export function fieldMaxLength(maxLength: number) {
    return v => (v && v.length <= maxLength) || 'El campo no debe exceder el límite de caracteres';
}

export function fieldMaxLengthOrEmpty(maxLength: number) {
    return v =>
        v == undefined
            ? true
            : v.length <= maxLength || 'El campo no debe exceder el límite de caracteres';
}

export function timeRange(fromDateVal: string, toDateVal: string, timeVal: string) {
    return v =>
        fromDateVal != toDateVal ||
        timeVal < v ||
        'La hora de salida no puede ser anterior a la hora de entrada';
}

export function email() {
    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return v => pattern.test(v) || 'Email invalido';
}

export function specialCharacters(exception: Array<string> | undefined = undefined) {
    let patternString = "['`]";
    if (exception != undefined) {
        exception.forEach(character => {
            patternString = patternString.replace(character, '');
        });
    }
    const pattern = new RegExp(patternString);
    return v => !pattern.test(v) || 'El campo contiene caracteres no permitidos';
}

export function allowedValues(array: any[]) {
    return v => array.some(value => v == value) || 'Requerido';
}

export function noSpacesAllowed() {
    const pattern = /\s+/;
    return v => !pattern.test(v) || 'No se permiten espacios en blanco';
}

export function lettersNumbersAndHyphensAllowed() {
    const pattern = /^([0-9]( |-)?)?(\(?[0-9]{3}\)?|[0-9]{3})( |-)?([0-9]{3}( |-)?[0-9]{4}|[a-zA-Z0-9]{7})$/;
    return v => !pattern.test(v) || 'Solo se permiten letras, números y guiones';
}

export function allowedDecimals() {
    const pattern = /^([0-9]{1,3}(,[0-9]{1,3})*)$/;
    return v => pattern.test(v) || 'Excede el valor máximo permitido 999,999';
}

export function allowLettersExclusively() {
    const pattern = /^\D+$/;
    return v => pattern.test(v) || 'Solo se permiten letras';
}

export function allowNumbersExclusively() {
    const pattern = /^[0-9]*$/;
    return v => pattern.test(v) || 'Solo se permiten números';
}

export function allowAlphanumericValues() {
    const pattern = /^[a-zA-Z0-9]*$/;
    return v => pattern.test(v) || 'Únicamente valores alfanuméricos';
}

export function notEmpty() {
    return v => (v && v.length > 0) || 'Requerido';
}

export function validPhone() {
    const pattern = /^\+{1}[0-9]{2}\s{1}\([0-9]{3}\)\s{1}[0-9]{3}[0-9]{4}$/;
    return v => pattern.test(v) || 'Número inválido';
}

export function validTime(date: string) {
    return v => {
        let isAfter: boolean = moment(`${date} ${v}`, 'YYYY-MM-DD HH:mm').isAfter(
            moment().add(1, 'hours'),
        );

        return isAfter
            ? true
            : 'La hora de entrada debe ser, como mínimo, una hora después de la hora actual';
    };
}

export function validatePlate() {
    return v => {
        const regexp = new RegExp(
            /^([0-9a-z]{7}|[a-z]{3}\-?[0-9]{2}[a-z]{1}|[a-z]{3}\-?[0-9]{3}|TT\-[0-9]{5}|[0-9]{1}\-[0-9]{2}-[a-y]{1}|[0-9]{2}\-[a-y]{1})$/gi,
        );

        return regexp.test(v) ? true : 'Mínimo 6 caracteres en combinación de letras y números';
    };
}

export function isDuplicated(otherValue: any) {
    return v =>
        (v && v.localeCompare(otherValue, undefined, { sensitivity: 'base' })) ||
        'Las placas tienen que ser distintas';
}
